import styled from 'styled-components';
import { Button, media } from '@minerva-analytics/pantheon';
import { FaCheckCircle, FaCircle } from 'react-icons/fa';
import { ORANGE, BLUE, BLACK, LIGHT_ORANGE, LIGHT_BLUE } from 'root/theme';

const OptionListContainer = styled.div`
  display: flex;
  justify-content: space-around;
  flex-flow: wrap;
  padding: 1.5rem 0;

  ${media.tablet`
  `}

  ${media.phone`
    padding: 0;
  `}
`;

const OptionContainer = styled.div`
  margin: 0 0 1rem;
  width: 300px;

  ${media.tablet`
    width: 100%;
  `}
`;

const UnclickedCircle = styled(FaCircle).attrs({
  fill: `${LIGHT_ORANGE}`,
})`
  font-size: 40px;
  margin-left: auto;
  transition: .4s;
`;

const Option = styled(Button)`
  width: 100%;
  min-height: 4rem;
  border-radius: 50px;
  border: 2px solid ${(props) => props.selected ? BLUE : ORANGE};
  color: ${(props) => props.selected ? BLUE : BLACK};
  display: flex;
  font-size: 14px;
  align-items: center;
  justify-content: center;
  padding: 0.75em;
  transition: .4s;
  font-weight: 600;

  &:hover {
    border: 2px solid ${BLUE};
    color: ${BLUE};

    ${UnclickedCircle} {
      fill: ${LIGHT_BLUE};
    }
  }

  ${media.phone`
    font-size:12px;
  `}
`;

const Text = styled.h4`
  margin-left: auto;
  max-width: 80%;
`;

const CircularCheckmark = styled(FaCheckCircle).attrs({
  fill: `${BLUE}`,
})`
  font-size: 40px;
  margin-left: auto;
`;

export {
  OptionListContainer,
  OptionContainer,
  Option,
  CircularCheckmark,
  UnclickedCircle,
  Text,
};

